import { Box, Typography } from "@mui/material";
import { useState } from "react";
import useColors from "../../../../api/hooks/useColors";
import PercentageLabel from "../../frameworks/components/PercentageLabel";
import NISTCategoryIdentifier from "../../controls/components/NISTCategoryIdentifier";
import CategoryDrawer from "./CategoryDrawer";

const NISTCategory = ({ nistFunction, category }) => {
  const colors = useColors();
  const [openDrawer, setOpenDrawer] = useState(false);
  if (!category) return null;

  return (
    <Box
      sx={{
        borderRadius: "8px",
        p: "14px",
        minWidth: "378px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        height: "80px",
        background: colors.common_white,
        cursor: "pointer",
        boxShadow: `1px 1px 0px 1px  ${colors.grey_12percent}`,
        border: `1px solid ${colors.grey_12percent}`,
        "&:hover": {
          boxShadow: `0px 0px 0px 2px ${colors.grey_12percent}`,
        },
      }}
      onClick={(e) => {
        setOpenDrawer(true);
      }}
    >
      <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <NISTCategoryIdentifier
            nistFunction={nistFunction.function}
            nistIdentifiers={[category?.id]}
          />
          <PercentageLabel
            applicable={category.score >= 0}
            percentage={category.score >= 0 ? category.score : 0}
            sx={{ borderRadius: "10px", height: "20px" }}
          />
        </Box>
        <Typography variant="body2">{category.name.split("(")[0]}</Typography>
      </Box>

      <CategoryDrawer
        open={openDrawer}
        onClose={(e) => {
          e.stopPropagation();
          setOpenDrawer(false);
        }}
        category={category}
        nistFunction={nistFunction}
      />
    </Box>
  );
};

export default NISTCategory;
